import { useAuth } from '@/features/auth/hooks/useAuth';
import { useContractCompliance } from '@/features/contracts/api';
import { useFiscalProfile } from '@/features/fiscal/api';

export function useProfessionalOnlineEligibility() {
  const { user } = useAuth();
  const fiscal = useFiscalProfile();
  const contracts = useContractCompliance();

  const fiscalComplete = fiscal.data?.isComplete ?? false;
  const fiscalSuspended = fiscal.data?.statoProfilo === 'sospeso';
  const contractsAccepted = contracts.data?.allAccepted ?? false;
  const phoneVerified = user?.profile?.phoneVerified ?? false;
  const isLoading = fiscal.isLoading || contracts.isLoading;
  const isError = fiscal.isError || contracts.isError;

  const missingRequirements: string[] = [];
  if (!isLoading && !isError) {
    if (!fiscalComplete) missingRequirements.push('completa il profilo fiscale');
    if (!contractsAccepted) missingRequirements.push('accetta tutti i contratti e documenti');
    if (fiscalSuspended) missingRequirements.push('profilo sospeso per limite EUR 5.000 raggiunto');
    if (!phoneVerified) missingRequirements.push('inserisci e verifica il tuo numero di telefono');
  }

  return {
    canGoOnline:
      !isLoading && !isError && fiscalComplete && contractsAccepted && !fiscalSuspended && phoneVerified,
    isLoading,
    isError,
    missingRequirements,
  };
}
